import { useCallback, useEffect, useState } from 'react';
import { getDetectedDisplayLocale } from './displayLocale';
import { formatDisplayDate, formatDisplayDateTime } from './formatDisplayDate';

function syncLocale(): string {
    return getDetectedDisplayLocale();
}

/** Re-renders when IP/locale country detection completes on app load. */
export function useDisplayLocale(): string {
    const [locale, setLocale] = useState(syncLocale);

    useEffect(() => {
        const onCountryDetected = () => setLocale(syncLocale());
        onCountryDetected();
        window.addEventListener('countryCodeDetected', onCountryDetected);
        return () => window.removeEventListener('countryCodeDetected', onCountryDetected);
    }, []);

    return locale;
}

export function useFormatDisplayDate() {
    const locale = useDisplayLocale();
    return useCallback(
        (value: string | Date | null | undefined) => formatDisplayDate(value, locale),
        [locale]
    );
}

export function useFormatDisplayDateTime() {
    const locale = useDisplayLocale();
    return useCallback(
        (value: string | Date | null | undefined) => formatDisplayDateTime(value, locale),
        [locale]
    );
}
